const LANGUAGE_STORAGE_KEY = 'LANG'

// 检查浏览器语言
const checkLang = function () {
  // 优先检查本地存储设置的语言
  if (window.localStorage) {
    let storage = localStorage.getItem(LANGUAGE_STORAGE_KEY)
    if (storage != undefined && storage != null && storage != 'null' && storage != '') {
      return storage
    }
  }

  // 检查浏览器语言
  let browserLanguage = (navigator.browserLanguage || navigator.language).toLowerCase()
  let langs = browserLanguage.split('-')
  if (langs[0] == 'zh') {
    return 'zh'
  } else if (langs[0] == 'ja') {
    return 'en'
  }
}

// 本地存储网语言
const storageLang = function (lang) {
  if (window.localStorage) {
    return localStorage.setItem(LANGUAGE_STORAGE_KEY, lang)
  }
}

module.exports = {
  checkLang: checkLang,
  storageLang: storageLang
}



// WEBPACK FOOTER //
// ./src/assets/lang/lang.js